import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "supplier-catalogue-recent-orders" }
const _hoisted_2 = { class: "supply-orders__head" }
const _hoisted_3 = {
  key: 0,
  class: "supply-orders__list"
}
const _hoisted_4 = {
  key: 0,
  class: "loading-skeleton"
}
const _hoisted_5 = {
  key: 1,
  class: "placeholder"
}
const _hoisted_6 = {
  key: 1,
  class: "supply-orders__list"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "supply-orders__list-item-head" }
const _hoisted_9 = { class: "bold" }
const _hoisted_10 = { class: "supply-orders__list-item-status" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_skeleton = _resolveComponent("q-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("h5", { class: "bold" }, "Recent orders", -1)),
      _createVNode(_component_q_btn, {
        unelevated: "",
        rounded: "",
        onClick: [
          _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          $setup.toOrders
        ]
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("span", null, "View Orders & Drafts ", -1),
          _createElementVNode("div", { class: "t-icon lowercase" }, "b", -1)
        ])),
        _: 1
      })
    ]),
    (!$setup.items?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_q_skeleton, { type: "rect" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_skeleton, { type: "text" }),
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"50%"}
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_skeleton, { type: "rect" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_skeleton, { type: "text" }),
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"50%"}
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_skeleton, { type: "rect" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_skeleton, { type: "text" }),
                    _createVNode(_component_q_skeleton, {
                      type: "text",
                      style: {"width":"50%"}
                    })
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, "No orders yet"))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.items, (order) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "supply-orders__list-item",
              onClick: ($event: any) => ($setup.toOrders(order.sys.id))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h6", _hoisted_9, _toDisplayString(order.reference), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((order.status || []), (status) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["notice inline dense order__status", { error: ['failed'].includes(status), warn: ['pending'].includes(status), success: ['resolved','transiting','final'].includes(status) }])
                  }, _toDisplayString($setup.formatStatus(status)), 3))
                }), 256))
              ])
            ], 8, _hoisted_7))
          }), 256))
        ]))
  ]))
}